module.exports = __webpack_public_path__ + "static/media/img2-1.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/K/img2-1.png
// module id = 1288
// module chunks = 3